// import React from "react";
// import css from "./popUp.module.css";

// const PopUpDrop = React.forwardRef((props, ref) => {
//   return (
//     <div className={css.dropPopWrapNew} ref={ref}>
//       <p className={css.mainPopP}>
//         Ми підтримуємо дропшипінг і працюємо над створенням сервісу. Для нас це
//         прототип нової культури продажів. Ми беремо на себе всі операції з
//         товарами та забезпечуємо промо текстами й картинками, ваше завдання –
//         шукати покупців. Всі умови індивідуальні. Порядок процедури: обговорюєте
//         умови з Лесею Кухарчук (
//         <a href="tel:+380508893545">+38 050 88 93 545</a>{" "}
//         <a href="mailto:sales@chasmaistriv.com.ua">sales@chasmaistriv.com.ua</a>
//         ); реєструєтесь зі статусом "Дропшипінг"; зручний сервіс замовлення на
//         сайті в розділі "Прайс-гурт", зручний довіз, звіти.
//       </p>
//     </div>
//   );
// });

// export default PopUpDrop;

import React from "react";
import css from "./popUp.module.css";
import { db } from "../../firebase"; // скоригуй шлях під свій
import { doc, onSnapshot } from "firebase/firestore";

const DOC_ID = "dropshipping"; // колекція: popups / документ: dropshipping

const PopUpDrop = React.forwardRef((props, ref) => {
  const [html, setHtml] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const unsub = onSnapshot(doc(db, "popups", DOC_ID), (snap) => {
      setLoading(false);
      setHtml(snap.exists() ? snap.data()?.contentHtml || "" : "");
    });
    return () => unsub();
  }, []);

  return (
    <div className={css.dropPopWrapNew} ref={ref} onClick={props?.onClick}>
      <div
        className={`${css.mainPopP} ${css.ubuntuFont}`}
        dangerouslySetInnerHTML={{ __html: loading ? "…" : html }}
      />
    </div>
  );
});

export default PopUpDrop;
